import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faBriefcase, faCalendar } from '@fortawesome/free-solid-svg-icons';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { process } from '@progress/kendo-data-query';
import { SVGIcon, searchIcon } from '@progress/kendo-svg-icons';
import { AdminService } from '../../../../modules/administration/services/admin.service';

import { Params } from '@angular/router';
import { DialogResult, DialogService } from '@progress/kendo-angular-dialog';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { AssessmentPannelSchedulerDailogComponent } from 'src/app/modules/provider-management/components/assessment-pannel-scheduler-dailog/assessment-pannel-scheduler-dailog.component';
import { ProviderType } from 'src/app/shared/enums/provider-type';
import { EvaluatorProvider } from '../../../../modules/administration/interfaces/evaluator-providers';

@Component({
  selector: 'app-evaluator-providers',
  templateUrl: './evaluator-providers.component.html',
  styleUrls: ['./evaluator-providers.component.scss'],
  standalone: false,
})
export class EvaluatorProvidersComponent implements OnChanges {
  @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective;
  @ViewChild('excelexport') excelexport: ExcelExportComponent;
  public gridView: EvaluatorProvider[];
  loadSpinner: boolean;
  agencyId: string;
  @Input() locationDetails: any;
  type: string;
  evaluatorExportModel: EvaluatorProvider[];
  public allProviders: EvaluatorProvider[] = [];

  public briefCaseIcon: SVGIcon = this.customFaIcon(faBriefcase);
  public calendarIcon: SVGIcon = this.customFaIcon(faCalendar);
  public searchIcon: SVGIcon = searchIcon;
  public providerTypes: typeof ProviderType = ProviderType;
  providerNameWithID: string;
  constructor(
    private adminService: AdminService,
    private route: ActivatedRoute,
    private router: Router,
    public dialogService: DialogService,
    private cdRef: ChangeDetectorRef,
    private viewContainerRef: ViewContainerRef
  ) {
    this.route.params.subscribe((params: Params) => {
      this.agencyId = params.id;
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.locationDetails) {
      this.getEvaluatorProviders();
    }
  }

  customFaIcon(icon: IconDefinition): SVGIcon {
    return {
      name: icon.iconName,
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      content: `<path d="${icon.icon[4]}" />`,
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      viewBox: `0 0 ${icon.icon[0]} ${icon.icon[1]}`,
    };
  }

  public onAgencyGridFilter(value: string | null | undefined): void {
    const term = (value || '').trim();

    if (term) {
      this.gridView = process(this.allProviders, {
        filter: {
          logic: 'or',
          filters: [
            { field: 'firstName', operator: 'contains', value: term },
            { field: 'lastName', operator: 'contains', value: term },
            { field: 'fullName', operator: 'contains', value: term },
            { field: 'id', operator: 'contains', value: term },
          ],
        },
      }).data as EvaluatorProvider[];
      this.dataBinding.skip = 0;
    } else {
      this.gridView = this.allProviders.slice();
    }
  }
  openScheduleCalendar(dataItem: EvaluatorProvider): void {
    const providerSk = dataItem.evaluatorProviderSk;
    if (dataItem) {
      if (dataItem?.type !== 5) {
        this.providerNameWithID = `${dataItem?.firstName}` + (dataItem?.lastName ? ` ${dataItem?.lastName}` : '') + (dataItem?.id ? `(${dataItem?.id})` : '');

      } else {
        this.providerNameWithID = `${dataItem?.firstName}` + (dataItem?.lastName ? ` ${dataItem?.lastName}` : '') + (dataItem?.id ? `(${dataItem?.id})` : '');

      }
    }
    const dialogRef = this.dialogService.open({
      title: dataItem?.type === 5 ? 'Evaluator Schedule' : 'Provider Schedule',
      width: 1166,
      height: '90vh',
      content: AssessmentPannelSchedulerDailogComponent,
      appendTo: this.viewContainerRef,
    });

    const instance = dialogRef.content
      .instance as AssessmentPannelSchedulerDailogComponent;

    instance.userProviderSK = dataItem.evaluatorProviderSk;
    instance.isEditable = true;
    instance.dataItem = dataItem;
    instance.providerName = this.providerNameWithID;
    instance.isAssessment = dataItem?.type === 5 ? true : false;
    dialogRef.result.subscribe((result: DialogResult) => {
      // dialog closed; handle if needed
    });
  }
  isNew(lastModifiedDate: string | Date): boolean {
    const modified = new Date(lastModifiedDate);
    const today = new Date();

    modified.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    const diff =
      (today.getTime() - modified.getTime()) / 86400000;

    return diff <= 5 && diff >= 0;
  }
  getEvaluatorProviders(): void {
    this.loadSpinner = true;
    this.adminService
      .getEvaluatorProvidersByAgency(this.locationDetails?.agencySk)
      .subscribe((res: EvaluatorProvider[]) => {
        const mapped: {
          fullName: string;
          id: string;
          firstName: string;
          lastName: string;
          emailAddress: string;
          phoneno: string;
          evaluatorProviderSk: string;
          noOfStudents: number;
        }[] = res.map(item => ({
          ...item,
          fullName: `${item.firstName ?? ''} ${item.lastName ?? ''}`.trim()
        }));
        this.allProviders = mapped;
        this.gridView = mapped;
        this.evaluatorExportModel = res;
        this.cdRef.markForCheck();
        this.loadSpinner = false;
      });
  }
  public navigateToProviderAgency(data): void {
    this.router.navigate(
      [
        '/admin/agency-mde/provider-information',
        this.locationDetails?.agencySk,
        data?.evaluatorProviderSk,
        data?.type
      ],
      {
        state: {
          locationDetails: this.locationDetails,
          providerData: data
        }
      }
    );
  }
}
